<div class="page-title animatedBackground">
    <div class="container">
        <h3>Event</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Manage Event</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="contact-area ptb-50">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <h3>Add Event</h3>
            </div>

            <div class="mt-4 col-lg-12 col-md-12">
                <form id="contactForm" [formGroup]="eventForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="eventTitle" class="form-control"
                                    placeholder="Event Title">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventTitle')?.invalid && eventForm.get('eventTitle')?.touched">
                                    Event Title is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="eventSubTitle" class="form-control"
                                    placeholder="Event Subtitle">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventSubTitle')?.invalid && eventForm.get('eventSubTitle')?.touched">
                                    Event Subtitle is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="eventOrganizer" class="form-control"
                                    placeholder="Event Organizer">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventOrganizer')?.invalid && eventForm.get('eventOrganizer')?.touched">
                                    Event Organizer is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="number" formControlName="eventAmount" class="form-control"
                                    placeholder="Event Amount">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventAmount')?.invalid && eventForm.get('eventAmount')?.touched">
                                    Event Amount is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="number" formControlName="eventLimit" class="form-control"
                                    placeholder="Event Limit">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventLimit')?.invalid && eventForm.get('eventLimit')?.touched">
                                    Event Limit is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="datetime-local" formControlName="eventDate" class="form-control"
                                    placeholder="Event Time">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventDate')?.invalid && eventForm.get('eventDate')?.touched">
                                    Event Date & Time is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <label for="formFile" class="form-label">Upload Event Image</label>
                            <div class="form-group">
                                <input class="form-control" formControlName="eventImagePath" type="file" id="formFile">
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventImagePath')?.invalid && eventForm.get('eventImagePath')?.touched">
                                    Event Image is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" formControlName="eventDescription" class="form-control"
                                    id="message" cols="30" rows="4" placeholder="Event Description"></textarea>
                                <div class="form-error-message"
                                    *ngIf="eventForm.get('eventDescription')?.invalid && eventForm.get('eventDescription')?.touched">
                                    Event Description is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="btn btn-primary me-md-3"
                                (click)="clickOnSubmit()">Submit</button>
                            <button type="submit" class="pl-2 btn btn-danger" (click)="clearEvent()">Clear</button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="mt-5 col-lg-12 col-md-12">
                <table class="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Title</th>
                            <th scope="col">Subtitle</th>
                            <th scope="col">Organizer</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Limit</th>
                            <th scope="col">Date & Time</th>
                            <th scope="col">Description</th>
                            <th scope="col">Image</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let event of eventsList; let i=index">
                            <th scope="row">{{i+1}}</th>
                            <td>{{event.eventTitle}}</td>
                            <td>{{event.eventSubTitle}}</td>
                            <td>{{event.eventOrganizer}}</td>
                            <td>{{event.eventAmount}}</td>
                            <td>{{event.eventLimit}}</td>
                            <td>{{event.eventDate}}</td>
                            <td>{{event.eventDescription}}</td>
                            <td class="w-80"><button type="button" class="btn btn-link">View</button></td>
                            <td class="w-145">
                                <button type="button" class="btn btn-primary btn-sm me-md-2"
                                    (click)="getEventById(event?._id)">Edit</button>
                                <button type="button" class="btn btn-danger btn-sm"
                                    (click)="deleteAdminEvent(event?._id)">Delete</button>
                            </td>
                        </tr>
                        <tr *ngIf="eventsList.length == 0" class="text-center">
                            <td colspan="8">No Data Found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>